import React, { CSSProperties, FC, useEffect, useState } from 'react';

const Checkbox: FC <Props> = ({
  checked,
  onChange,
  style,
  iconStyle,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    setIsChecked(checked || false);
  }, [checked]);

  const handleChange = (isChecked: boolean) => {
    setIsChecked(isChecked);
    if (onChange) {
      onChange(isChecked);
    }
  };

  return (
    <div
      onClick={() => {
        handleChange(!isChecked);
      }}
      style={{
        border: '2px solid #11202B',
        borderRadius: '2px',
        width: 12,
        height: 12,
        cursor: 'pointer',
        backgroundColor: isChecked ? '#00D2B9' : 'transparent',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ...style,
      }}
    >
      <i
        className="fa fa-check"
        style={{ fontSize: 11, color: '#FFFFFF', opacity: isChecked ? 1 : 0, ...iconStyle }}
      />
    </div>
  );
};

export interface Props {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
}

export default Checkbox;
